import { render, staticRenderFns } from "./CreateTenant.vue?vue&type=template&id=58236775"
import script from "./CreateTenant.vue?vue&type=script&lang=js"
export * from "./CreateTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports